var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAbPageIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M27.5195 10.3895C27.9976 9.71194 29.0024 9.71194 29.4805 10.3895L50.9807 40.8581C51.5416 41.653 50.9731 42.75 50.0002 42.75H6.99977C6.02687 42.75 5.45837 41.653 6.0193 40.8581L27.5195 10.3895Z",
    fill: "#0e131c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1113 34.9126L25.6738 38.4751L35.1738 28.9751",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 14.25H33.25C38 14.25 38 11.875 38 9.5C38 4.75 35.625 4.75 33.25 4.75H23.75C21.375 4.75 19 4.75 19 9.5C19 14.25 21.375 14.25 23.75 14.25Z",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 9.54761C45.9087 9.97511 49.875 12.8964 49.875 23.7501V38.0001C49.875 47.5001 47.5 52.2501 35.625 52.2501H21.375C9.5 52.2501 7.125 47.5001 7.125 38.0001V23.7501C7.125 12.9201 11.0913 9.97511 19 9.54761",
    stroke: "#0e131c",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbPageIcon01);
export default __webpack_public_path__ + "static/media/ab-page-icon01.bfe92ca8be8ab8044a662f0ac63c9d78.svg";
export { ForwardRef as ReactComponent };